<template>
  <div style="height: 100%" >
    <div id="cardQ">
      <div id="question">
        {{testedWord.lemma.decenglish}}
      </div>
      <quiz-answer
          :answer="testedWord.lemma.decenglish"
          :propositions="randomWordsList"
          @answer="relayAnswer">

      </quiz-answer>
    </div>
  </div>
</template>

<script>

export default {
  name: "vocabularyQuiz",

  components: {
    quizAnswer: () => import(/* webpackPrefetch: true */ '@/components/quizAnswer.vue')
  },

  props: {
    testedWord: Object,
    wordsList: Array,
    chosenLemmaIndex: Number
  },

  created() {
    this.wordsList.splice(this.chosenLemmaIndex, 1);
    this.randomWordsList = this.selectRandomPropositions(this.wordsList.slice(), this.testedWord);
  },

  methods: {
    selectRandomPropositions: function(wordsList, testedWord) {
      let tempList = wordsList.slice(); // copie de wordsList
      let randomList = []; // liste randomisée à construire
      randomList[0] = testedWord;

      //Si deux traductions françaises identiques coexistent dans tempList, on supprime la deuxième occurence
      let listCopy = tempList.slice();
      for (let i = 0; i < listCopy.length; i++) {
        // On supprime des propositions le mot correspondant à celui à deviner
        if (listCopy[i].lemma.separateTrads[0] === testedWord.lemma.separateTrads[0]) {
          tempList.splice(i, 1);
        }
        else if (!testedWord.lemma.is_vulgar && testedWord.lemma.is_vulgar) {
          tempList.splice(i, 1);
        }
        for (let j = 0; j < listCopy.length; j++) {
          if (listCopy[i].lemma.separateTrads[0] === listCopy[j].lemma.separateTrads[0] && j !== i) {
            tempList.splice(j, 1);
          }
        }
      }

      // On sélectionne autant que possible des mots de même types comme propositions
      if (testedWord.lemma.word_type === "n") {
        let filteredList = tempList.filter(word => word.lemma.word_type == "n").slice();
        if (filteredList.length > this.choicesNumber) {
          tempList = filteredList;
        }
      } else if (testedWord.lemma.word_type === "v") {
        let filteredList = wordsList.filter(word => word.lemma.word_type == "v").slice();
        if (filteredList.length > this.choicesNumber) {
          tempList = filteredList;
        }
      } else if (testedWord.lemma.word_type === "adj") {
        let filteredList = wordsList.filter(word => word.lemma.word_type == "adj").slice();
        if (filteredList.length > this.choicesNumber) {
          tempList = filteredList;
        }
      } else {
        let filteredList = wordsList.filter(word => word.lemma.word_type == "adv").slice();
        if (filteredList.length > this.choicesNumber) {
          tempList = filteredList;
        }
      }

      for (let i = 1; i < this.choicesNumber; i++) {
        //On vérifie que nbAlea n'ira pas chercher plus loin que la longueur de notre Array list0
        let randomNb = this.nbAlea(0, tempList.length);

        randomList[i] = tempList[randomNb];
        tempList.splice(randomNb, 1);
      }
      randomList.splice(this.nbAlea(1, this.choicesNumber), 0, testedWord);

      return randomList;
    },

    nbAlea(min, max) {
      return Math.trunc((Math.random() * max + min));
    },

    relayAnswer(isCorrect) {
      this.$emit('answer', isCorrect)
    }
  },

  data() {
    return {
      randomWordsList: [],
      choicesNumber: 4
    }
  }
}
</script>

<style scoped>
#cardQ {
  position: relative;
  padding-top: 2vw;
  padding-bottom: 2vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  background-color: var(--color2);
}

#question {
  align-self: center;
  font-size: 300%;
  font-weight: bold;
  margin-bottom: 2vw;
}
</style>